const translations = {
    manageConnections: 'Manage Connections',
    shareTo: 'Share'
};

export default translations;
